import { styled } from '@mui/system';
import {
  TextField,
  Typography,
  Link as MaterialLink,
  FormControl,
} from '@mui/material';

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginLeft: 10,
  marginRight: 10,
  marginTop: 5,
  marginBottom: 90,
  '@media (min-width: 900px)': {
    marginLeft: '10%',
    marginRight: '10%',
  },
});
const TextFieldStyled = styled(TextField)({
  marginTop: '10px',
  height: '60px',
  '& .MuiInputBase-root': {
    backgroundColor: '#fff',
  },
});

const FormRootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 16,
  marginRight: 16,
  marginBottom: 12,
  '@media (min-width: 750px)': {
    marginLeft: '10%',
    marginRight: '10%',
  },
});

export const FormActionContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: 16,
  paddingRight: 16,
  paddingBottom: 12,
  paddingTop: 18,
  '@media (min-width: 750px)': {
    paddingLeft: '10%',
    paddingRight: '10%',
  },
});

const TitleTypography = styled(Typography)({
  marginTop: '24px',
});

const MaterialLinkStyled = styled(MaterialLink)({
  cursor: 'pointer',
  paddingTop: 15,
});

export const ButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: 16,
  width: '100%',
});

export const FormControlStyled = styled(FormControl)({
  marginTop: '10px',
  height: '60px',
  '& .MuiSelect-select': {
    backgroundColor: '#fff',
  },
});

export {
  RootDiv,
  TextFieldStyled,
  FormRootDiv,
  TitleTypography,
  MaterialLinkStyled,
};
